export const GRIP_WAIT_TIME_MS = 1000;

export const ONROBOT_TCP_PORT_DEFAULT = 502;

export const COMPUTEBOX_HOST_DEFAULT = 'COMPUTEBOX.localdomain';
